import { useState } from 'react';
import { config } from '../config/app';
import { useT } from '../i18n';

/*
    "Cihazlarımda nasıl kurarım" — ve neden GİRİŞ EKRANINDA duruyor.

    Bu rehbere ihtiyacı olan kişi, tanımı gereği henüz giriş yapmamış olan kişidir: yeni bir
    telefon kuruyor, Outlook'a hesabını ekliyor. Onu gelen kutusunun içine koymak, ihtiyacı
    olanın göremeyeceği tek yere koymak olurdu.

    Kapalı başlıyor. Giriş kartı bir formdur; her gün girenlerin önüne her gün bir kılavuz
    sermek, kılavuzu değil formu bozar.

    PUNTO: gövde `--fs-base`, başlıklar bir puntoluk üstü. İlk sürümde her şey `--fs-xs`
    (11,5px) yazılmıştı — sistemin en küçük belirteci, ipucu ve üstveri için ayrılmış olan.
    Kullanıcı okumakta zorlandığını söyledi ve haklıydı: bu metin ipucunun tam tersi, adım adım
    TAKİP EDİLEN bir metin, çoğu zaman telefonda ve çoğu zaman teknik olmayan biri tarafından.
    Satır yüksekliği de o yüzden 1.7.

    Hiçbir adres BURAYA GÖMÜLMEZ. Sunucu adı `/config.json`'dan gelir (kurulum kendi sunucusunu
    zaten bilir) ve boşsa ayar tablosu hiç çizilmez.
*/
export default function KurulumRehberi() {
    const { t } = useT();
    const [acik, setAcik] = useState(false);
    const brand = config();

    const baslik: React.CSSProperties = {
        fontSize: 'calc(var(--fs-base) + 1px)',
        fontWeight: 600,
        color: 'var(--text)',
        margin: '0 0 6px',
    };
    const metin: React.CSSProperties = {
        fontSize: 'var(--fs-base)',
        color: 'var(--text-mute)',
        lineHeight: 1.7,
        margin: '0 0 8px',
    };
    const bolum: React.CSSProperties = { marginBottom: 'var(--sp-6, 20px)' };

    // Adımlar numaralı bir listede: sırayla yapılacak bir işin sırası görünür olmalı.
    const Adimlar = ({ anahtarlar }: { anahtarlar: string[] }) => (
        <ol style={{ ...metin, paddingLeft: '1.35em', margin: '0 0 8px' }}>
            {anahtarlar.map((k) => (
                <li key={k} style={{ marginBottom: 4 }}>
                    {t(k as Parameters<typeof t>[0])}
                </li>
            ))}
        </ol>
    );

    return (
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--sp-4)' }}>
            <button
                type="button"
                onClick={() => setAcik((v) => !v)}
                aria-expanded={acik}
                aria-controls="kurulum-rehberi"
                data-testid="kurulum-ac"
                style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    color: 'var(--accent-strong)',
                    fontSize: 'calc(var(--fs-base) + 1px)',
                    textDecoration: 'underline',
                    textUnderlineOffset: 3,
                }}
            >
                {acik ? t('kurulum.kapat') : t('kurulum.ac')}
            </button>

            {acik ? (
                <div
                    id="kurulum-rehberi"
                    data-testid="kurulum-rehberi"
                    style={{ marginTop: 'var(--sp-5)', textAlign: 'left' }}
                >
                    {/*
                        Otomatik yol EN ÜSTTE, ve bu bir sıralama tercihi değil ölçüm sonucu:
                        autoconfig canlıda çalışıyor, yani bu istemcilerde gerçekten e-posta ve
                        parola yetiyor. Elle ayar anlatıp otomatiği aşağı gömmek, insanlara
                        gereksiz iş yaptırmak olurdu.
                    */}
                    <div style={bolum}>
                        <h3 style={baslik}>{t('kurulum.otoBaslik')}</h3>
                        <p style={metin}>{t('kurulum.otoMetin')}</p>
                        <Adimlar anahtarlar={['kurulum.oto1', 'kurulum.oto2', 'kurulum.oto3']} />
                    </div>

                    {brand.androidAppUrl ? (
                        <div style={bolum}>
                            <h3 style={baslik}>{t('kurulum.androidBaslik')}</h3>
                            <p style={metin}>{t('kurulum.androidMetin')}</p>
                            <Adimlar anahtarlar={['kurulum.android1', 'kurulum.android2', 'kurulum.android3']} />
                            <a
                                href={brand.androidAppUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="kurulum-android"
                                style={{
                                    display: 'inline-block',
                                    padding: '9px 16px',
                                    borderRadius: 'var(--r-btn)',
                                    background: 'var(--accent-bg)',
                                    color: 'var(--accent-strong)',
                                    border: '1px solid var(--accent-strong)',
                                    fontSize: 'var(--fs-base)',
                                    fontWeight: 600,
                                    textDecoration: 'none',
                                }}
                            >
                                {t('kurulum.androidDugme')}
                            </a>
                        </div>
                    ) : null}

                    <div style={bolum}>
                        <h3 style={baslik}>{t('kurulum.outlookBaslik')}</h3>
                        <Adimlar
                            anahtarlar={[
                                'kurulum.outlook1',
                                'kurulum.outlook2',
                                'kurulum.outlook3',
                                'kurulum.outlook4',
                                'kurulum.outlook5',
                                'kurulum.outlook6',
                            ]}
                        />
                        <p style={{ ...metin, fontSize: 'var(--fs-sm)' }}>{t('kurulum.outlookNot')}</p>
                    </div>

                    {/*
                        iPhone için UYGULAMA LİNKİ YOK ve bu bilinçli: summail'in iOS sürümü
                        henüz yayında değil. Olmayan bir uygulamaya düğme koymak, kullanıcıyı
                        boş bir mağaza sayfasına göndermektir.
                    */}
                    <div style={bolum}>
                        <h3 style={baslik}>{t('kurulum.iphoneBaslik')}</h3>
                        <Adimlar
                            anahtarlar={[
                                'kurulum.iphone1',
                                'kurulum.iphone2',
                                'kurulum.iphone3',
                                'kurulum.iphone4',
                                'kurulum.iphone5',
                            ]}
                        />
                    </div>

                    <div style={bolum}>
                        <h3 style={baslik}>{t('kurulum.macBaslik')}</h3>
                        <Adimlar anahtarlar={['kurulum.mac1', 'kurulum.mac2', 'kurulum.mac3', 'kurulum.mac4']} />
                    </div>

                    {brand.imapAddr && brand.smtpAddr ? (
                        <div style={bolum}>
                            <h3 style={baslik}>{t('kurulum.elleBaslik')}</h3>
                            <p style={metin}>{t('kurulum.elleMetin')}</p>
                            <table
                                data-testid="kurulum-ayarlar"
                                style={{
                                    borderCollapse: 'collapse',
                                    fontSize: 'var(--fs-base)',
                                    color: 'var(--text-dim)',
                                    width: '100%',
                                    lineHeight: 1.6,
                                }}
                            >
                                <tbody>
                                    {[
                                        [t('kurulum.gelen'), `${brand.imapAddr}`, t('kurulum.sifreleme')],
                                        [t('kurulum.giden'), `${brand.smtpAddr}`, t('kurulum.sifreleme')],
                                        [t('kurulum.kullaniciAdi'), t('kurulum.kullaniciAdiDeger'), ''],
                                        [t('kurulum.parola'), t('kurulum.parolaDeger'), ''],
                                    ].map(([ad, deger, ek]) => (
                                        <tr key={ad}>
                                            <th
                                                scope="row"
                                                style={{
                                                    textAlign: 'left',
                                                    fontWeight: 500,
                                                    padding: '4px 12px 4px 0',
                                                    whiteSpace: 'nowrap',
                                                    verticalAlign: 'top',
                                                    color: 'var(--text-mute)',
                                                }}
                                            >
                                                {ad}
                                            </th>
                                            <td style={{ padding: '4px 0' }}>
                                                {deger}
                                                {ek ? (
                                                    <span style={{ color: 'var(--text-mute)' }}> · {ek}</span>
                                                ) : null}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <p style={{ ...metin, fontSize: 'var(--fs-sm)', marginTop: 10 }}>
                                {t('kurulum.elleUyari')}
                            </p>
                        </div>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}
